import {defineComponent} from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlLoadingBar',
    props: {
        progress: { type: Number, required: false, default: 0}
    },
    setup(props) {
    }
})
